import { each, keys, values, includes } from 'lodash-es';
import helpers from '../../../../../utils/helpers';

export const rootNode = document.getElementById('prospect-top-charts-publishers-root');

export const initParams = () => ({
  generalData: JSON.parse(rootNode.dataset.data),
  report: JSON.parse(rootNode.dataset.report),
  defaultOsName: rootNode.dataset.defaultOsName,
  store: rootNode.dataset.store,
  shareOptions: JSON.parse(rootNode.dataset.shareOptions),
  data: JSON.parse(rootNode.dataset.data),
  availableCategories: JSON.parse(rootNode.dataset.availableCategories),
});

export const parseUrlForFilters = () => {
  const { pathname, search } = window.location;
  const allFilters = pathname.match(/\/top-charts\/top-publishers\/(google-play|itunes-connect)\/([a-z-]+)?\/([a-z-]+)?/);
  const defaultFilters = pathname.match(/\/top-charts\/top-publishers/);
  const urlParams = new URLSearchParams(search);
  let filters = { };
  if (allFilters) {
    filters = { store: allFilters[1], category: allFilters[2], country: allFilters[3] };
  }

  if (!allFilters && defaultFilters) {
    filters = { store: defaultFilters[1] };
  }

  if (urlParams.get('date')) {
    filters = { ...filters, date: urlParams.get('date') };
  }

  return filters;
};

export const getCategoryName = ({ category_id, store_id }) => {
  if (!category_id) { return ''; }
  let parentCategoryName;

  each(MULTILEVEL_CATEGORIES[store_id], (v) => {
    if (typeof v[1] === 'object') {
      if (includes(keys(values(v[1])[0]), category_id.toString())) {
        parentCategoryName = [keys(v[1])];
      }
    }
  });

  if (parentCategoryName) {
    return `${parentCategoryName} ${helpers.categoryNameForId(category_id, store_id)}`;
  }

  return helpers.categoryNameForId(category_id, store_id) || '';
};
export const storeName = store_id => ({
  itunes_connect: 'iTunes Connect',
  google_play: 'Google Play',
}[store_id]);

export const appOSName = store_id => ({
  itunes_connect: 'iOS',
  google_play: 'Android',
}[store_id]);

export const setDocumentTitle = ({ store_id, country_iso, category_id }) => {


  const country = COUNTRIES_ARRAY[country_iso];
  const categoryName = getCategoryName({ category_id, store_id });

  document.title = `${storeName} Top Apps Analysis for ${categoryName} in ${country} | Apptopia Top ${appOSName} Apps`;
};
